import axios from 'axios';
import store from "../../store/index";
import CriticalDPModal from '../CriticalDPPopup/CriticalDPModal.vue';

export default{
    name: 'criticalDataInventory',
    components: {
        CriticalDPModal,
    },
    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            studyId : "",
            idToken : store.getters.getIdToken,
            headerValues: {},

            processId :"",
            processName: "",
            criticalDataPoints: [],
            showTableLoader: false,
            showCriricalPopUp: false,
            selectedCriticalDP: {},

        };
    },
    async mounted() {
        this.idtoken = store.getters.getIdToken;
        this.studyId = store.getters.getStudyIs;
        console.log('CriticalDataInventory component mounted');
        this.headerValues = {
            headers: {
                Authorization: "Bearer " + this.idToken,
                "Content-Type": "application/json",
            },
        };
        window.addEventListener("studyIdChanged", (event) => {
            console.log("StudyIDChanged into" + event.detail.storage);
            this.studyId = event.detail.storage;
            this.getCriticalProcess();
        });
        await  this.getCriticalProcess();
    },
    methods: {
        async getCriticalProcess(){
            try{
                var res = await axios.get(`${this.baseurl}/forms/rbqm/getcriticalprocess?studyId=${this.studyId}&processId=${this.processId}&processName=${this.processName}&SortProperty=processId&SortOrder=0`, this.headerValues);
                console.log("Critical Data Points:", res.data.entities);
                this.criticalDataPoints = res.data.entities;
            }
            catch (error) {
                console.error("Error fetching critical data points:", error);
            }
        },
        async showCriticalDP(CriticalDP){
            console.log("Critical Data Point clicked:", CriticalDP);
            this.showCriricalPopUp = true;
            this.selectedCriticalDP = CriticalDP;
        },
        async closeCriticalDataPopup() {
            this.showCriricalPopUp = false;
            this.selectedCriticalDP = {};
        }
    },
   

}